import { createNamespacedHelpers } from "vuex";

const {mapGetters: userGetters} = createNamespacedHelpers("user"),
	{mapGetters: filtersGetters} = createNamespacedHelpers("filters");

export default {

	props: {value: Object, },

	computed: {
		...userGetters([
			"properties"
		]),
		...filtersGetters({
			"activeDateFromStore": "activeDate",
			"activePeriodFromStore": "activePeriod"
		})
	},

	data() {
		return {
			activePeriod: null,
			activeDate: null,
			filterItems: this.$utils.convertArrayToTranslatedObject.call(this, [
				"all",
				"starred",
				"noted",
				"incorrect_label_reported",
			], "trashevent.filter_"),
			filter: "all",
			orderItems: {
				timestamp: this.$t("trashevent.order_timestamp"),
				weight: this.$t("trashevent.order_weight")
			},
			order: "weight",
		};
	},

	mounted() {
		this.activeDate = this.activeDateFromStore;
		this.activePeriod = this.activePeriodFromStore;
	},

	methods: {handleFilterChange, },

	watch: {
		activePeriod: function() {
			this.handleFilterChange();
		},
		activeDate: function() {
			this.handleFilterChange();
		},
		filter: function() {
			this.$ma.trackEvent({
				action: "Trash Event Side Slider Filter used",
				properties: {
					"Value": this.filter,
					"Component": this.$route.name
				}
			});

			this.handleFilterChange();
		},
		order: function() {
			const order = this.order === "timestamp" ? "Most recent" : "Heighest weight";

			this.$ma.trackEvent({
				action: "Trash Event Side Slider Sort Used",
				properties: {
					"Value": order,
					"Component": this.$route.name
				}
			});

			this.handleFilterChange();
		},
	},

};

function handleFilterChange() {
	this.$emit("input", {
		activePeriod: this.activePeriod,
		activeDate: this.activeDate,
		filter: this.filter,
		order: this.order,
	});
}
